module.exports = __webpack_public_path__ + "img/color_multicolor_a-1629-3.e973d9f.jpg";